module.exports = __webpack_public_path__ + "static/media/location-outline.ac16e43f.svg";